/**
 * Convertit une chaîne `clé:valeur` (séparée par des virgules) en objet de
 * propriétés GSAP. Sert à surcoucher les valeurs de départ (FROM_VARS) ou
 * d'arrivée (TO_VARS) d'une animation via les attributs data-fromvars /
 * data-tovars.
 *
 * Ex : data-tovars="opacity:1,x:0,y:0,rotate:2deg"
 *
 * - absent / vide      → null (aucune surcouche)
 * - valeur numérique   → convertie en nombre (ex: "0" → 0)
 * - valeur non numérique → conservée en chaîne (ex: "2deg", "50%")
 */
export default function parseVars(raw) {
	if (!raw) return null;

	const vars = {};

	raw.split(";").forEach(pair => {
		const [key, ...rest] = pair.split(":");
		const prop = key?.trim();
		const rawValue = rest.join(":").trim();

		if (!prop || rawValue === "") return;

		const numeric = parseFloat(rawValue);
		vars[prop] = (!isNaN(numeric) && String(numeric) === rawValue) ? numeric : rawValue;
	});

	return Object.keys(vars).length ? vars : null;
}
